module.exports = __webpack_public_path__ + "img/addwhite-icon.17ecffd5.svg";